<template>
<div class="page-inner mt-5">
  <div class="card mb-3">
    <div class="card-body">
      <h3 class="font-thin text-dark strong">{{ $t('request_placement') }}</h3>
      <div>
        <label>{{ $t('sending_to') }}</label>
        <p class="strong">
          <a :href="playlist.url" target="_blank" class="text-primary">{{ playlist.title }}</a>
        </p>
      </div>
    </div>
  </div>
  <section class="scrollable">
    <div class="card">
      <div class="card-body">
        <form class="form" @submit.prevent="requestPlacement">
          <div class="form-group">
            <label>{{ $t('artist') }}</label>
            <select class="form-control" v-model="song.artist">
              <option :value="artist._id" v-for="artist in artists" v-bind:key="artist._id">
                {{ artist.name }}
              </option>
            </select>
          </div>
          <div class="form-group">
            <label>{{ $t('genre') }}</label>
            <select class="form-control" v-model="song.main_genre">
              <option :value="genre" v-for="genre in genres" v-bind:key="genre">
                {{ genre }}
              </option>
            </select>
          </div>
          <div class="form-group">
            <label>Spotify Track URL</label>
            <input v-model="song.url" type="url" class="form-control">
            <div v-if="song.url && song.url.match(/track\//)" class="mt-2 alert alert-warning">
              {{ $t('verify_link') }}: <a class="ml-1" :href="song.url" target="_blank">{{ $t('open_new_window') }} <i class="fa fa-external-link-alt"></i></a>
            </div>
            <div class="mt-2 alert alert-danger" v-if="song.url && !song.url.match(/track\//)">
              {{ $t('invalid_channel_link') }}: <br/>
              <a href="https://open.spotify.com/track/5l6yhYGGIqhZEFZVHMrgVz?si=OqUZXxQgSNG9mjd72w2O2w" target="_blank">https://open.spotify.com/track/5l6yhYGGIqhZEFZVHMrgVz?si=OqUZXxQgSNG9mjd72w2O2w</a>
            </div>
          </div>
          <div class="form-group">
            <label class="font-bold">{{ $t('please_read') }}</label>
            <div class="alert alert-warning">
              <span class="h4 font-thin">
                {{ $t('request_will_cost') }} <b>{{ playlist.cost_per_placement }} {{ $t('credits') }}</b>.<br/>
                {{ $t('if_not_accepted') }}<br/><br/>
                {{ $t('playlist_placement_duration') }}
              </span>
            </div>
          </div>
          <div class="form-group">
            <label class="font-bold">{{ $t('i_agree') }}</label>
            <input type="checkbox" v-model="iAgree" class="ml-2">
            <button v-bind:disabled="creating || !iAgree" type="submit" class="btn btn-primary ml-4">{{ $t('send_request') }}</button>
          </div>
        </form>
      </div>
    </div>
  </section>
</div>
</template>
<script>
import genres from '../data/genres'
import _ from 'lodash'

export default {
  data: function () {
    return {
      credits: 0,
      iAgree: false,
      genres: _.map(genres, (genre, key) => {
        return key
      }),
      playlist: {},
      artists: [],
      creating: false,
      song: {
        artist: '',
        url: '',
        main_genre: 'Alternative'
      },
      loading: true
    }
  },
  methods: {
    getArtists: function () {
      this.$http.get(`${window.apiURL}api/user/artists`, { withCredentials: true }).then(response => {
        this.artists = response.data

        if (this.artists[0]) {
          this.song.artist = this.artists[0]._id
        }
      }, () => {})
    },
    requestPlacement () {
      if (this.creating) return

      this.creating = true

      if (!this.song.url) {
        return
      }

      if (!this.song.url.match(/track/)) {
        return this.$notify({ message: this.$t('invalid_track_url') }, 'warning', 'fa-exclamation')
      }

      if (this.playlist.cost_per_placement > this.credits) {
        return this.$notify({ message: this.$t('no_enough_credits') }, 'warning', 'fa-exclamation')
      }

      this.$http.post(`${window.apiURL}api/playlist-request/${this.playlist._id}`, this.song, { withCredentials: true }).then(response => {
        this.$router.push('/playlists')
        this.$notify({ message: this.$t('playlist_request_sent') }, 'success', 'fa-check')
      }, (err) => {
        this.$notify({ message: this.$t('already_sent_to_playlist') }, 'warning', 'fa-exclamation')
        console.log('Error creating campaign', err)
        this.creating = false
      })
    }
  },
  created () {
    this.$http.get(`${window.apiURL}api/playlists/${this.$route.params.id}`, { withCredentials: true }).then(response => {
      this.playlist = response.data
    })

    this.$http.get(`${window.apiURL}api/user/credits`, { withCredentials: true }).then(response => {
      this.credits = response.data.available || 0
    })

    this.getArtists()
  }
}
</script>



// WEBPACK FOOTER //
// src/components/PlaylistRequest.vue